<template>
  <div class="container-fluid main_content">
    <location-line :step1="'사고관리'" :step2="'세부 사고관리'"/>
    <div class="carinfo_box">
      <div class="row ml-0">
        <div class="col-3">
          <ul class="carinfo m-0">
            <li class="logo_box">
              <div class="logo" :style="brandIconBg(carInfo.brand)"><span class="d-none">{{ carInfo.brand }}</span>
              </div>
            </li>
            <li class="info">
              <p class="car_number">{{ carInfo.num }}</p>
              <p class="car_model">{{ (carInfo.year) ? carInfo.year + '년' : '' }} {{ carInfo.brand }} {{
                  carInfo.cname
                }}</p>
            </li>
            <li class="addr">
              <p class="company">{{ carInfo.csname }} {{ carInfo.cssname }}</p>
              <p class="state"><span
                :class="(carInfo.brk === '1') ? 'text-muted' : 'text-success' ">{{
                  (carInfo.brk === '0') ? '운행중' : '주차'
                }}</span>
                │
                <span class="text-danger beta">소모품 교체 권장</span></p>
            </li>
          </ul>
        </div>
        <div class="col-9">
          <div class="carstatus row mr-0">
            <ul class="col-6 pt-4">
              <li>
                <label><i><img src="/img/icon/icon_mileage.png" height="20" width="20"/></i>총 주행거리</label>
                {{ carInfo.total_km | comma }}Km
              </li>
              <li>
                <label><i><img src="/img/icon/icon_location.png" height="20" width="20"/></i>현위치</label>
                <span class="beta">미구현</span>
              </li>
              <li>
                <label><i><img src="/img/icon/icon_repair2.png" height="20" width="20"/></i>근처 정비소</label>
                <span class="beta">미구현</span>
              </li>
              <li>
                <label><i><img src="/img/icon/icon_driver.png" height="20" width="20"/></i>운전자</label>
                {{ carInfo.uname }}
              </li>
              <li>
                <label><i><img src="/img/icon/icon_phone.png" height="20" width="20"/></i>운전자 연락처</label>
                {{ carInfo.utel }}
              </li>
            </ul>
            <ul class="col-6 pt-4">
              <li>
                <label><i><img src="/img/icon/icon_time.png" height="20" width="20"/></i>최근 사고시간</label>
                {{ carInfo.last_issue_datetime }}
              </li>
              <li>
                <label><i><img src="/img/icon/icon_location.png" height="20" width="20"/></i>최근 사고장소</label>
                <span class="beta">미구현</span>
              </li>
              <li>
                <label><i><img src="/img/icon/icon_insurance.png" height="20" width="20"/></i>보험사</label>
                <span>{{ carInfo.ins_company }}</span>
              </li>
              <li>
                <label><i><img src="/img/icon/icon_calendar_b.png" height="20" width="20"/></i>보험 시작일</label>
                <span>{{ carInfo.ins_sdate }}</span>
              </li>
              <li>
                <label><i><img src="/img/icon/icon_calendar_b.png" height="20" width="20"/></i>보험 만료일</label>
                <span>{{ carInfo.ins_edate }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="sub_content">
      <div class="row">
        <div class="col-4 col-sm-4 col-md-4" style="max-width: 300px;">
          <label class="title">사고인지 날짜</label>
          <VCalendar ref="calendar"
                     :dates="dates"
                     @selectedDay="selectedDay"
                     @changeCalendar="changeCalendar"/>
        </div>
        <div class="col-8 col-sm-8 col-md-3 pl-0">
          <label class="title">시간별 사고인지</label>
          <div class="times">
            <ul class="time_line" v-for="( item, index ) in items" :key="index"
                @click="issueDayListClick(index)"
                :class="{active :(index === issueDayListIndex)}"
            >
              <li class="time">{{ index + 1 }}.{{ item.indate }}</li>
              <li class="line">
                <div class="ricon"></div>
              </li>
              <li class="addr beta">미구현</li>
              <li class="arrow"><img src="/img/icon/icon_arrow_right.png" height="20" width="20"/></li>
            </ul>
            <p v-if="items.length === 0">
              검색을 원하는 날짜를 선택해주세요.
            </p>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-5 pl-0 pl-sm-3">
          <label class="title">사고인지 스틸컷</label>
          <b-carousel
            class="still"
            id="carousel-1"
            no-animation
            :interval="500"
            background="#fff"
            img-height="270"
            style="text-shadow: 1px 1px 2px #333;"
          >
            <b-carousel-slide img-height="270" :img-src="item" class="inner_img"
                              v-for="(item, index) in stillCuts" :key="index">
            </b-carousel-slide>
            <!--
            <b-carousel-slide img-height="270" img-src="/img/sample/1.jpg" class="inner_img"></b-carousel-slide>
            <b-carousel-slide img-height="270" img-src="/img/sample/2.jpg" class="inner_img"></b-carousel-slide>
            <b-carousel-slide img-height="270" img-src="/img/sample/3.jpg" class="inner_img"></b-carousel-slide>
            <b-carousel-slide img-height="270" img-src="/img/sample/4.jpg" class="inner_img"></b-carousel-slide>
            <b-carousel-slide img-height="270" img-src="/img/sample/5.jpg" class="inner_img"></b-carousel-slide>
            <b-carousel-slide img-height="270" img-src="/img/sample/7.jpg" class="inner_img"></b-carousel-slide>
            <b-carousel-slide img-height="270" img-src="/img/sample/8.jpg" class="inner_img"></b-carousel-slide>
            <b-carousel-slide img-height="270" img-src="/img/sample/9.jpg" class="inner_img"></b-carousel-slide>
            <b-carousel-slide img-height="270" img-src="/img/sample/10.jpg" class="inner_img"></b-carousel-slide>
            <b-carousel-slide img-height="270" img-src="/img/sample/11.jpg" class="inner_img"></b-carousel-slide>
            -->
          </b-carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LocationLine from '@/components/LocationLine'
import VCalendar from '@/components/common/calendar/VCalendar'
import brandIconBg from '@/mixin/brandIconBg'
import '@/filter/common'
import { carInfoEx } from '@/api/car'
import ax from '@/api/issue'
import _ from 'lodash'

export default {
  name: 'IssueView',
  mixins: [brandIconBg],
  components: {
    LocationLine,
    VCalendar
  },
  data () {
    return {
      dates: [],
      carInfo: {},
      items: [],
      issueDayListIndex: null,
      selectedDate: null,
      stillCuts: []
    }
  },
  mounted () {
    if (this.$route.params.seq) {
      carInfoEx(this.$route.params.seq, (data) => {
        if (data) {
          this.carInfo = data
        }
      })
    }
  },
  methods: {
    selectedDay (date) {
      this.selectedDate = this.$moment(date).format('YYYY-MM-DD')

      ax.issueDayList(this.$route.params.seq, this.selectedDate, response => {
        if (response)
          this.items = response
      })
    },
    changeCalendar (startDate, endDate) {
      ax.issueMonthCount(this.$route.params.seq, this.$moment(startDate).format('YYYY-MM-DD'), this.$moment(endDate).format('YYYY-MM-DD'), response => {
        this.dates = response
      })
    },
    issueDayListClick (index) {
      this.issueDayListIndex = index
      ax.getStillcut(this.$route.params.seq, this.items[index].seq, this.selectedDate, response => {
        this.stillCuts = _.map(response, function (n) {
          return `/api/v1/issue/get-image/${n.seq}`
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.carinfo_box {
  height: 200px;

  .carinfo {
    height: 100%;
    background-color: #F5FAFF;
    border-radius: 8px;
    list-style: none;
    padding: 20px;

    .logo_box {
      padding-top: 5px;
      text-align: left;

      .logo {
        display: inline-block;
        height: 40px;
        width: 40px;
        background: {
          image: url('/img/company/1.png');
          repeat: no-repeat;
          position: center center;
        }
      }
    }

    .info {
      padding-top: 4px;

      .car_number {
        font-size: 16px;
        margin: 0;
      }

      .car_model {
        font-size: 14px;
        margin: 0;
      }
    }

    .addr {
      padding-top: 4px;

      .company {
        font-size: 14px;
        margin: 0;
      }

      .state {
        font-size: 14px;
        margin: 0;
      }
    }

  }

  .carstatus {
    height: 100%;
    background-color: #F8F8FB;
    border-radius: 8px;
    font-size: 12px;

    ul {
      list-style: none;
      margin-bottom: 0px;
    }

    li {
      padding: 5px 0px;
    }

    li > label {
      vertical-align: top;
      color: #979799;
      width: 100px;
      margin-bottom: 0px;

      i > img {
        vertical-align: top;
        margin-top: -1px;
        margin-right: 3px;
      }
    }
  }
}


.sub_content {
  padding-top: 20px;
  padding-left: 15px;

  .title {
    font-size: 12px;
  }

  .times {
    width: 100%;
    height: 330px;
    border: 1px solid #eee;
    border-radius: 8px;
    padding: 15px;
    overflow-y: auto;

    .time_line {
      list-style: none;
      font-size: 12px;
      margin-bottom: 0px;
      cursor: pointer;

      &:last-child {
        height: 20px;
        overflow-y: hidden;
      }

      li {
        display: inline-block;
        vertical-align: middle;
        height: 30px;

        &.time {
          width: 22%;
          color: #979799;
        }

        &.line {
          background-color: #eee;
          width: 2px;
          position: relative;

          .ricon {
            position: absolute;
            top: 6px;
            left: -2px;
            width: 6px;
            height: 6px;
            background-color: #fff;
            border: 1px solid #007DEF;
            border-radius: 50%;
            box-sizing: border-box;
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
          }
        }

        &.addr {
          padding-left: 20px;
          width: calc(100% - 22% - 2px - 20px);
        }

        &.arrow {
          width: 20px;
        }
      }

      &.active, &:hover {
        color: #007DEF !important;

        .time {
          color: #007DEF !important;
        }

        .ricon {
          background-color: #007DEF !important;
        }
      }
    }
  }

  ::v-deep.still {
    width: 100%;
    height: 330px;
    border: 1px solid #eee;
    border-radius: 8px;
    padding: 15px;

    .inner_img img {
      width: auto !important;
      height: 300px !important;
    }
  }

  ::v-deep.custom_vcalendar .custom_vcalendar_title .custom_vcalendar_display_title {
    font-size: 16px;
  }
}


</style>
